import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslate } from '../../../mixins/translate/translate';
import { fetchGet } from '../../../store/fetch';
import { PanelRouterLink, Topbar, TopbarLeft, TopbarRight, TopbarWithTabs } from '../../elements';
import { useReactAsync } from '../../utils/useReactAsync';

async function loadBatch({ batchId }: { batchId?: undefined | string }) {
    if (batchId) {
        const url = `/api/batches/${batchId}`;
        const result = await fetchGet(url);
        return result.json;
    }
    return [];
}

export function TopBar(props: { batchId?: undefined | string; activeTab: 'addEdit' | 'documents' }) {
    const translate = useTranslate();
    const { data } = useReactAsync(loadBatch, { batchId: props.batchId }, []);

    return (
        <Topbar>
            <TopbarLeft>
                <TopbarWithTabs icon="fa-briefcase " title={props.batchId ? (data ? data.name : '') : translate('common.addItem', 'Batch')}>
                    <li className={props.activeTab === 'addEdit' ? 'active' : ''}>
                        <Link to={`/batches/${props.batchId}/edit`}>Batch</Link>
                    </li>
                    <li className={props.activeTab === 'documents' ? 'active' : ''}>
                        <Link to={props.batchId ? `/batches/${props.batchId}/documents` : '#'}>{translate('survey.documents')}</Link>
                    </li>
                </TopbarWithTabs>
            </TopbarLeft>
            {props.batchId && (
                <TopbarRight>
                    <PanelRouterLink to={`/batches/${props.batchId}`} text={translate('common.showItem', 'Batch')} icon="fa fa-search" small={true} />
                </TopbarRight>
            )}
        </Topbar>
    );
}
